// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__iIb5Z","percentage":"style_percentage__Noh00"};